/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 *  Type tag used to distinguish different types of nodes in a {@link ISummaryTree}.
 */
// eslint-disable-next-line @typescript-eslint/no-namespace
export var SummaryType;
(function (SummaryType) {
    /**
     *  Represents a sub-tree in the summary.
     */
    SummaryType.Tree = 1;
    /**
     * Represents a blob of data that is added to the summary.
     * Such as the user data that is added to the DDS or metadata added by runtime
     * such as data store / channel attributes.
     */
    SummaryType.Blob = 2;
    /**
     * Path to a summary tree object from the last successful summary.
     */
    SummaryType.Handle = 3;
    /**
     * Unique identifier to larger blobs uploaded outside of the summary.
     * Ex. DDS has large images or video that will be uploaded by the BlobManager and
     * receive an Id that can be used in the summary.
     */
    SummaryType.Attachment = 4;
})(SummaryType || (SummaryType = {}));
//# sourceMappingURL=summary.js.map